const mapCustomBrandNameToTenant = (subdomain: string) => {
    const customBrandNames: { [key: string]: string } = {
        apple: 'CodeDefender'
    };
    return customBrandNames[subdomain] || '';
};

export default mapCustomBrandNameToTenant;
